import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'

@Injectable()

export class BehaviourSettingServices {

    index: any = 0
    status: any = ''
    level: any
    array: any[] = []
    identifyTimeline: any
    view: any = ''
    state: any
    dataSaveSetting: any[] = []

    arrayTimeline: any[] = []
    jsonUndo: any = {}
    jsonBehaviorSetting: any = {}

    constructor() {
    }

    changeEmittedStatusOptionSetting$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedOptionSetting$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedArrOptionSetting$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedStatusFormSetting$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedFormSetting$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedStatusDetailFormSetting$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedLevelIndexMutiItem$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedCountLevelItem$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedArrFormSetting$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedjsonFormSetting$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedOldId$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedLevel$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedStatusConditionTarget$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedStatusConditionValue$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedValueConditionTarget$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedValueConditionValue$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedIsActiveModalFormInTimeline$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedJsonBehaviorSetting$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedArrTimeline$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedIdentifyTimeline$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedView$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedState$: BehaviorSubject<any> = new BehaviorSubject(null)

    resetDataAllBehaviour$: BehaviorSubject<any> = new BehaviorSubject(null)

    dataSaveSetting$: BehaviorSubject<any> = new BehaviorSubject(null)


    arrFormSettingUndo$: BehaviorSubject<any> = new BehaviorSubject(null)

    emitChangeSaveSetting(change: any) {
        if (change && change['data']) {
            this.dataSaveSetting = change['data']
        }
        this.dataSaveSetting$.next(change)
    }

    returnChangeDataSaveSetting() {
        return this.dataSaveSetting
    }

    emitChangeResetDataAll(change: any) {
        this.resetDataAllBehaviour$.next(change)
    }

    emitChangeArrFormSettingUndo(change: any) {
        this.jsonUndo = change
        this.arrFormSettingUndo$.next(change)
    }

    returnArrUndo() {
        return this.jsonUndo
    }

    emitChangeArrFormSetting(change: any) {
        this.array = change
        this.changeEmittedArrFormSetting$.next(change)
    }

    emitChangeState(change: any) {
        if (change != null && change != undefined && change['state'] != undefined) {
            this.state = change['state']
        }
        this.changeEmittedState$.next(change)
    }

    returnState() {
        return this.state
    }

    emitChangeView(change: any) {
        if (change != null && change != undefined && change['view'] != undefined) {
            this.view = change['view']
        } else {
            this.view = null
        }
        this.changeEmittedView$.next(change)
    }

    returnView() {
        return this.view
    }

    emitChangeArrTimeline(change: any) {
        this.arrayTimeline = change
        this.changeEmittedArrTimeline$.next(change)
    }

    returnArrTimeline() {
        return this.arrayTimeline
    }


    returnArr() {
        return this.array
    }

    emitChangeIdentifyTimeline(change: any) {
        this.identifyTimeline = change
        this.changeEmittedIdentifyTimeline$.next(change)
    }

    getIdentifyTimeline() {
        return this.identifyTimeline
    }

    emitChangeIsActiveModalFormInTimeline(change: any) {
        this.changeEmittedIsActiveModalFormInTimeline$.next(change)
    }

    emitChangeJsonBehaviorSetting(change: any) {
        this.jsonBehaviorSetting = change
        this.changeEmittedJsonBehaviorSetting$.next(change)
    }

    returnJsonBehaviorSetting() {
        return this.jsonBehaviorSetting
    }

    getArrFormSetting() {
        return this.array
    }

    emitChangeValueConditionTarget(change: any) {
        this.changeEmittedValueConditionTarget$.next(change)
    }

    emitChangeValueConditionValue(change: any) {
        this.changeEmittedValueConditionValue$.next(change)
    }

    emitChangeJsonFormSetting(change: any) {
        this.changeEmittedjsonFormSetting$.next(change)
    }

    emitChangeStatusConditionTarget(change: any) {
        this.changeEmittedStatusConditionTarget$.next(change)
    }

    emitChangeStatusConditionValue(change: any) {
        this.changeEmittedStatusConditionValue$.next(change)
    }

    emitChangeLevel(change: any) {
        this.changeEmittedLevel$.next(change)
    }

    emitChangeOldId(change: any) {
        this.changeEmittedOldId$.next(change)
    }


    emitChangeStatusOptionSetting(change: any) {
        this.changeEmittedStatusOptionSetting$.next(change)
    }

    emitChangeOptionSetting(change: any) {
        this.changeEmittedOptionSetting$.next(change)
    }

    emitChangeArrOptionSetting(change: any) {
        this.changeEmittedArrOptionSetting$.next(change)
    }

    emitChangeFormSetting(change: any) {
        this.changeEmittedFormSetting$.next(change)
    }

    emitChangeStatusFormSetting(change: any) {
        this.changeEmittedStatusFormSetting$.next(change)
    }

    emitChangeStatusDetailFormSetting(change: any) {
        if (change != null) {
            this.status = change
        }
        this.changeEmittedStatusDetailFormSetting$.next(change)
    }

    getStatusDetail() {
        return this.status
    }

    emitChangeLevelIndexMultiItem(change: any) {
        if (change != null && change['identify-' + this.level] != undefined) {
            this.index = change['identify-' + this.level]
        }
        this.changeEmittedLevelIndexMutiItem$.next(change)
    }

    emitChangeCountLevel(change: any) {
        if (change != null && change['identify'] != undefined) {
            this.level = change
        }
        this.changeEmittedCountLevelItem$.next(change)
    }

    getLevel() {
        return this.level
    }

    getShowStatus(index) {

        const status: any = this.status['statusDetailForm-' + index]

        return status
    }
}



// WEBPACK FOOTER //
// ./src/app/services/BehaviourSetting.services.ts